import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

const api = axios.create({ baseURL: `${API_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err.response?.status === 401 && localStorage.getItem("accessToken")) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("usuario");
        window.location.href = "/admin/login";
      }
      return Promise.reject(err);
    }
);

export const UPLOADS_URL = API_URL;

export const imgUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${UPLOADS_URL}${url}`;
};

// ─── Auth ──────────────────────────────────────────────────────
export const authAPI = {
  login: (data) => api.post("/auth/login", data),
  verify2fa: (data) => api.post("/auth/verify-2fa", data),
  me: () => api.get("/auth/me"),
  setup2fa: () => api.get("/admin/2fa/setup"),
  enable2fa: (data) => api.post("/admin/2fa/enable", data),
  disable2fa: (data) => api.post("/admin/2fa/disable", data),
  accessLog: () => api.get("/admin/access-log"),
  cambiarPassword: (data) => api.post("/admin/me/password", data),
};

// ─── Propiedades públicas ──────────────────────────────────────
export const portalAPI = {
  listar: (params) => api.get("/properties", { params }),
  destacadas: () => api.get("/properties/featured"),
  detalle: (slug) => api.get(`/properties/${slug}`),
  similares: (slug) => api.get(`/properties/similar/${slug}`),
  stats: () => api.get("/stats/public"),
  contacto: (data) => api.post("/contacts", data),
};

// ─── Admin ─────────────────────────────────────────────────────
export const adminAPI = {
  dashboard: () => api.get("/admin/dashboard"),
  listar: (params) => api.get("/admin/properties", { params }),
  detalle: (id) => api.get(`/admin/properties/${id}`),
  crear: (data) => api.post("/admin/properties", data),
  actualizar: (id, data) => api.put(`/admin/properties/${id}`, data),
  patch: (id, data) => api.patch(`/admin/properties/${id}`, data),
  eliminar: (id) => api.delete(`/admin/properties/${id}`),
  duplicar: (id) => api.post(`/admin/properties/${id}/duplicate`),
  subirImagenes: (id, formData) =>
      api.post(`/admin/properties/${id}/images`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      }),
  actualizarImagen: (id, imgId, data) =>
      api.patch(`/admin/properties/${id}/images/${imgId}`, data),
  eliminarImagen: (id, imgId) =>
      api.delete(`/admin/properties/${id}/images/${imgId}`),
  reordenarImagenes: (id, order) =>
      api.post(`/admin/properties/${id}/images/reorder`, { order }),
  listarLeads: (params) => api.get("/admin/contacts", { params }),
  actualizarLead: (id, data) => api.patch(`/admin/contacts/${id}`, data),
  crearLead: (data) => api.post("/admin/contacts", data),
  eliminarLead: (id) => api.delete(`/admin/contacts/${id}`),
  // Usuarios
  listarUsuarios: () => api.get("/admin/users"),
  crearUsuario: (data) => api.post("/admin/users", data),
  eliminarUsuario: (id) => api.delete(`/admin/users/${id}`),
  resetearPassword: (id, password) => api.patch(`/admin/users/${id}/password`, { password }),
};

// ─── Ciudades ──────────────────────────────────────────────────
export const ciudadesAPI = {
  listar: () => api.get("/ciudades"),
  crear: (nombre) => api.post("/admin/ciudades", { nombre }),
  eliminar: (id) => api.delete(`/admin/ciudades/${id}`),
};

// ─── Estados ───────────────────────────────────────────────────
export const estadosAPI = {
  listar: () => api.get("/estados"),
  crear: (nombre) => api.post("/admin/estados", { nombre }),
  eliminar: (id) => api.delete(`/admin/estados/${id}`),
};

// ─── Settings ──────────────────────────────────────────────────
export const settingsAPI = {
  publicas: () => api.get("/settings/public"),
  obtener: () => api.get("/admin/settings"),
  guardar: (data) => api.put("/admin/settings", data),
  subirLogo: (file, tipo = "logo") => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post(`/admin/settings/logo?tipo=${tipo}`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};

export default api;